
const AdminRadio = ({
    mt = "mt-2",
    checked = false, 
    label = "", 
    onChange,
    disabled = false,
    name = ""
}) => {
    return (
        <div className={`form-check ${mt}`}
            data-tip
            data-for="tncTooltip">
            <input
                className="form-check-input"
                type="checkbox"
                id={name}
                checked={checked}
                onChange={onChange}
                disabled={disabled}
                name={name}
            />
            <label className={`form-check-label tw:!text-[15px] tw:!text-[#8D8D8D] ${checked && `fw-700`}`} htmlFor={name}>
                {label}
            </label>
        </div>
    );
};

export default AdminRadio;